/**
 * These variables are added globally from the Django application.
 * We declare them once here so that we can import where needed
 * throughout the React application.
 */

/* eslint-disable no-undef */
export const static_url = STATIC_URL;
export const csrf_token = CSRF_TOKEN;
/* eslint-enable no-undef */
